/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

import { Injectable } from '@angular/core';

import { NzMenuBaseService } from 'ant-reset-private/core';

@Injectable()
export class NzMenuService extends NzMenuBaseService {
  isInDropDown = false;
}
